module.exports = __webpack_public_path__ + "media/images/service/icon-9e42b86d2ab134431213e3b06302e096.png";